import { Plus, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ANIMALS } from "@/lib/activity";

const slots = (type) => (type === "sapi" ? 7 : 1);

export const QurbanEditor = ({ animals = [], onChange }) => {
  const setAnimal = (i, patch) => onChange(animals.map((a, idx) => (idx === i ? { ...a, ...patch } : a)));
  const setName = (i, j, v) => {
    const names = [...(animals[i].names || [])];
    names[j] = v;
    setAnimal(i, { names });
  };
  return (
    <div className="space-y-3 sm:col-span-2" data-testid="qurban-editor">
      <div className="flex items-center justify-between">
        <p className="text-sm font-medium">Daftar Hewan Qurban <span className="text-slate-400 font-normal">({animals.length})</span></p>
        <Button type="button" size="sm" variant="outline" className="rounded-full h-8" onClick={() => onChange([...animals, { type: "kambing", names: [""] }])} data-testid="qurban-add-animal"><Plus size={14} className="mr-1" /> Tambah Hewan</Button>
      </div>
      {animals.map((a, i) => (
        <div key={i} className="rounded-2xl border border-emerald-900/10 p-4 space-y-3 bg-[#fcfdf9]">
          <div className="flex items-center gap-2">
            <span className="text-sm font-semibold text-emerald-950">Hewan #{i + 1}</span>
            <Select value={a.type} onValueChange={(v) => setAnimal(i, { type: v, names: Array.from({ length: slots(v) }, (_, j) => a.names?.[j] || "") })}>
              <SelectTrigger className="h-9 w-40" data-testid={`qurban-${i}-type`}><SelectValue /></SelectTrigger>
              <SelectContent>{Object.entries(ANIMALS).map(([k, v]) => <SelectItem key={k} value={k}>{v}</SelectItem>)}</SelectContent>
            </Select>
            <span className="text-xs text-slate-500">{slots(a.type)} shohibul qurban</span>
            <button type="button" className="ml-auto text-slate-400 hover:text-red-600" onClick={() => onChange(animals.filter((_, idx) => idx !== i))} data-testid={`qurban-${i}-remove`}><Trash2 size={15} /></button>
          </div>
          <div className="grid sm:grid-cols-2 gap-2">
            {Array.from({ length: slots(a.type) }, (_, j) => (
              <Input key={j} className="h-9" placeholder={`Nama shohibul qurban ${j + 1}`} value={a.names?.[j] || ""} onChange={(e) => setName(i, j, e.target.value)} data-testid={`qurban-${i}-name-${j}`} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
